// options used in the Select Organization Header
// if generated by Adesk user, these options must be chosen between to display insted of Adesk company name
export const organizationOptions = [
  { value: "crewmama", name: "Crew Mama" },
  { value: "gtt", name: "Go To Team" },
  { value: "adesk", name: "Assignment Desk" },
  { value: "mcs", name: "Media Content Services" },
]

// based on the api value for crewmama_or_gtt,
// this func returns the appropriate name property based on the organization option below
export default function convertAdeskToOrganization(organizationValue) {
  let selectedOrganization = organizationOptions
    .map(opt => (opt.value === organizationValue ? opt.name : null))
    .join("")
  return selectedOrganization
}
